const normalizeUrl = (value: string): string => value.trim().replace(/\/$/, '');

// The legacy portal's Sentry project; production builds report there unless
// VITE_SENTRY_DSN says otherwise ("off" disables reporting).
const LEGACY_SENTRY_DSN = 'https://d0466e9673d2f0606734f136e23e03c8@pan-sentry-01.nlt.services/35';

// Runtime first: the container entrypoint writes /env.js from the Deployment's
// variables, so one image serves every environment (see entrypoint.sh).
// Build time second: .env.local for `vite dev` and the test runner.
const runtime = typeof window === 'undefined' ? undefined : window.__ENV__;
const runtimeApiUrl = runtime?.VITE_BASE_URL?.trim();
const rawApiUrl = runtimeApiUrl || import.meta.env.VITE_BASE_URL;

if (!rawApiUrl) {
  throw new Error('VITE_BASE_URL is required. Set it on the container, or copy .env.example to .env.local.');
}

const apiUrl = normalizeUrl(rawApiUrl);

if (!/^https?:\/\//.test(apiUrl)) {
  throw new Error('VITE_BASE_URL must be an absolute HTTP(S) URL.');
}

// A production bundle must never carry a local API URL baked in. A local value
// injected at runtime (running the image on a workstation) is fine.
if (import.meta.env.PROD && !runtimeApiUrl && /localhost|127\.0\.0\.1/.test(apiUrl)) {
  throw new Error('Production builds cannot bake a local API URL.');
}

const normalizeDsn = (value: string | undefined): string | undefined => {
  if (value === undefined) return undefined;
  const trimmed = value.trim();
  return trimmed === '' || trimmed === 'off' || trimmed === 'disabled' ? '' : trimmed;
};

const sentryDsn = normalizeDsn(runtime?.VITE_SENTRY_DSN)
  ?? normalizeDsn(import.meta.env.VITE_SENTRY_DSN)
  ?? (import.meta.env.PROD ? LEGACY_SENTRY_DSN : '');

const inferEnvironment = (): string => {
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname;
  if (hostname === 'portal.trini.app') return 'production';
  if (hostname.endsWith('.trinitech.site')) return 'test';
  if (hostname.endsWith('.pages.dev')) return 'preview';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'development';
  return import.meta.env.MODE;
};

const sentryEnvironment = runtime?.VITE_SENTRY_ENVIRONMENT?.trim()
  || import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim()
  || inferEnvironment();

export const env = Object.freeze({ apiUrl, sentryDsn, sentryEnvironment });
